import { useEffect, useState } from "react";
import bibtexParse from "bibtex-parse-js";

function parseBibFile(jsonText) {
  return jsonText.map((entry) => ({
    id: entry.citationKey,
    type: entry.entryType,
    title: entry.entryTags.title || "",
    author: entry.entryTags.author.split("and").map((author)=>(author.trim())) || "",
    year: entry.entryTags.year || "",
    journal: entry.entryTags.journal || entry.entryTags.booktitle || "",
    volume: entry.entryTags.volume || "",
    number: entry.entryTags.number || "",
    pages: entry.entryTags.pages || "",
    doi: entry.entryTags.doi || entry.entryTags.url || "",
  }));
}

function BibEntry({ entry }) {
  const regex = /^(Woo|Eungyu|우\s*은규)$/;
  entry.author = entry.author.map((auth) => {
    return (regex.test(auth))?'<u><strong>'+auth+'</strong></u>':auth;
  });
  var authortext = entry.author.slice(0,-1).join(', ') + (entry.author.length > 1 ? ", & " : "") + entry.author.at(-1);
  return (
    <div className="bibentry">
      <ul>
        <li>
          <span dangerouslySetInnerHTML={{__html: authortext}}></span>.
          ({entry.year}).&nbsp;
          {entry.title}.&nbsp;
          <i>{entry.journal}</i>
          {entry.volume?<i>, {entry.volume}</i>:""}
          {entry.number?<span>({entry.number})</span>:""}
          {entry.pages? <span>, {entry.pages}</span>:""}.&nbsp;
          {entry.doi ? <span>[<a href={entry.doi}>DOI</a>]</span> : ""}
        </li>
      </ul>
    </div>
  );
}

function BibList({ entries }) {
  if (!entries.length) return <p className="text-gray-500">불러오는 중...</p>;

  const sorted = [...entries].sort((a, b) => (b.year || 0) - (a.year || 0));

  return (
    <div>
      {sorted.map((entry) => (
        <BibEntry key={entry.id} entry={entry} />
      ))}
    </div>
  );
}


function Publications() {
    const [articles, setArticles] = useState([]);
    const [conferences, setConferences] = useState([]);


    // journal.bib 자동 불러오기
    useEffect(() => {
    async function loadBib() {
        try {
        const response = await fetch("/Data/publications.bib");
        const text = await response.text();
        const jsonText = bibtexParse.toJSON(text);
        var articlelist = [], conferencelist = [];
        jsonText.forEach((cur, idx, arr) =>{
            if(cur.entryType === 'article') articlelist.push(cur);
            else if(cur.entryType === 'conference') conferencelist.push(cur);
        });
        setArticles(parseBibFile(articlelist));
        setConferences(parseBibFile(conferencelist));
        } catch (error) {
            console.error("Failed to load BibTeX:", error);
        }
    }
    loadBib();
    }, []);

    return(
        <div>
            <h2>
              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="book" className="svg-inline logo_hsize" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"></path></svg>
              Publications
            </h2>
            <div>
                <h3 className="pub-title">Journal</h3>
                <BibList entries={articles} />
                <h3 className="pub-title">Conference</h3>
                <BibList entries={conferences} />
            </div>
        </div>
    );
}

export default Publications;